import { Stack, Typography, useTheme } from '@mui/material';
import Logo from './common/Logo';

const EmptyProjectPlaceholder = () => {
  const theme = useTheme();
  const textColor = theme.palette.getContrastText(theme.palette.background.default);
  return (
    <Stack
      direction='row'
      // height={`calc(100vh - (${theme.mixins.toolbar.minHeight}px - ${8}px))`}
      minHeight={0}
      height='100%'
      bgcolor={theme.palette.background.default}
    >
      <Stack width='100%' justifyContent='center' alignItems='center' direction='column'>
        <Logo
          sx={{
            fontSize: 400,
            filter: 'grayscale(00%) brightness(90%)',
            opacity: 0.2
          }}
          color='primary'
        />
        <Stack direction='row' gap={2} width='75%'>
          <Stack direction='column' alignItems='end' gap={1} width='100%' flexGrow={2}>
            <Typography variant='body1' color={textColor} gutterBottom>
              New application
            </Typography>
            <Typography variant='body1' color={textColor} gutterBottom>
              Open application
            </Typography>
            <Typography variant='body1' color={textColor} gutterBottom>
              Import/Export JSON
            </Typography>
          </Stack>
          <Stack direction='column' alignItems='start' gap={1} width='100%' flexGrow={2}>
            <Typography variant='body1' color={textColor}>
              <code>File</code> ➝ <code>New</code>
            </Typography>
            <Typography variant='body1' color={textColor}>
              <code>File</code> ➝ <code>Open</code>
            </Typography>
            <Typography variant='body1' color={textColor}>
              <code>File</code> ➝ <code>Import/Export</code>
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default EmptyProjectPlaceholder;
